import React from 'react';
import { Table } from 'antd';
import { formatToTL } from '../../utils';

type FieldEffortDisplayProps = {
  record: any;
  attributes?: any[];
};

const FieldEffortDisplay: React.FC<FieldEffortDisplayProps> = ({ record, attributes }) => {
  const proposalAttributes = record.attributes || [];

  // 3 offering’e ait “toplam dakika” tutalım
  let totalMachine = 0;
  let totalWorkHygiene = 0;
  let totalElectric = 0;

  // Teklif attrib’lerinden Makine / İş Hijyeni / Elektrik sahasını topla
  proposalAttributes.forEach((pa: any) => {
    const matched = attributes?.find((a: any) => a?.id === pa?.attributeId);
    if (matched) {
      const fieldTime = matched.fieldControlTime || 0;
      const qty = pa.quantity || 0;
      const period = pa.period || 0;
      const partial = fieldTime * (period * qty);

      if (matched.offering?.name === 'Makine') {
        totalMachine += partial;
      } else if (matched.offering?.name === 'İş Hijyeni') {
        totalWorkHygiene += partial;
      } else if (matched.offering?.name === 'Elektrik') {
        totalElectric += partial;
      }
    }
  });

  // Yukarı yuvarlama fonksiyonu
  const asDaysCeil = (minutes: number) => {
    if (minutes <= 0) return 0;
    const days = Math.ceil(minutes / 480);
    return `${days}`;
  };

  const asDaysCalc = (minutes: number) => {
    if (minutes <= 0) return 0;
    const days = minutes / 480;
    return days.toFixed(2);
  };

  // Metinler
  const machineText = totalMachine > 0 ? `${asDaysCeil(totalMachine)}` : '-';
  const workHygieneText = totalWorkHygiene > 0 ? `${asDaysCeil(totalWorkHygiene)}` : '-';
  const electricText = totalElectric > 0 ? `${asDaysCeil(totalElectric)}` : '-';

  let totalMachinePrice = 0;
  let totalWorkHygienePrice = 0;
  let totalElectricPrice = 0;

  record.priceCalculationResponse.offeringLogs.forEach((logs: any) => {
    if (logs.offeringName === 'Makine') {
      totalMachinePrice += logs.finalPrice;
    } else if (logs.offeringName === 'İş Hijyeni') {
      totalWorkHygienePrice += logs.finalPrice;
    } else if (logs.offeringName === 'Elektrik') {
      totalElectricPrice += logs.finalPrice;
    }
  });

  const total = totalMachinePrice + totalElectricPrice + totalWorkHygienePrice;

  // Eğer hiç fiyat yoksa
  if (total === 0) return <span>-</span>;

  // İndirimli dağıtım
  const originalPrice = record.originalPrice || total;
  const discountedPrice = record.discountedPrice || 0;

  // Oranları bul
  const machineRatio = totalMachinePrice / total;
  const electricRatio = totalElectricPrice / total;
  const workHygieneRatio = totalWorkHygienePrice / total;

  // İndirimi dağıt
  const machineDiscount = Math.round(discountedPrice * machineRatio);
  const electricDiscount = Math.round(discountedPrice * electricRatio);
  const workHygieneDiscount = discountedPrice - machineDiscount - electricDiscount;

  // Yeni tutarlar
  const machineTotal = totalMachinePrice - machineDiscount;
  const electricTotal = totalElectricPrice - electricDiscount;
  const workHygieneTotal = totalWorkHygienePrice - workHygieneDiscount;

  const formatEffort = (text: string, minutes: number) => {
    if (text === '-') return '-';
    return `${text} (${asDaysCalc(minutes)})`;
  };

  const columns = [
    { title: 'Makine', dataIndex: 'machine', key: 'machine' },
    { title: 'Elektrik', dataIndex: 'electric', key: 'electric' },
    { title: 'İş Hijyeni', dataIndex: 'workHygiene', key: 'workHygiene' },
  ];

  const dataSource = [
    {
      key: 'effort',
      label: 'Efor',
      machine: formatEffort(machineText, totalMachine),
      electric: formatEffort(electricText, totalElectric),
      workHygiene: formatEffort(workHygieneText, totalWorkHygiene),
    },
    {
      key: 'price',
      label: 'Tutar',
      machine: formatToTL(machineTotal),
      electric: formatToTL(electricTotal),
      workHygiene: formatToTL(workHygieneTotal),
    },
  ];

  return (
      <Table
        size="small"
        pagination={false}
        columns={columns}
        dataSource={dataSource}
      />
  );
};

export default FieldEffortDisplay;
